//
//
//
//

export default {
  props: ['time'],
  data:function(){
    return {
      ShowReLoadModel:true,
      timer:null
    }
  },
  methods: {
    showConfirm() {
      if (!this.ShowReLoadModel) return;

      this.ShowReLoadModel = false;


      const _this = this;
      this.$vux.confirm.show({
        'title': "提示",
        'content': "网站版本已更新，点击确定进行更新",
        'show-cancel-button': false,//不起效果
        onConfirm() {
          _this.clickConfirm();
        }
      })
    },
    clickConfirm() {
      this.stopTimer();
      window.location.reload(true);
      localStorage.clear();
    },
    OrgTask() {
      var orgID = localStorage.getItem("orgId");
      if (orgID) {
        this.$tyh.getOrgVersion(orgID)
          .then((response) => {
            if (response.data.Status != 0) {
              return false;
            }
            var json = response.data;
            if (json.Status == 0) {
              const currentVersion = localStorage.getItem('orgVersion');
              if (currentVersion === null) {
                localStorage.setItem('orgVersion', json.Data);
              } else {
                if (json.Data !== currentVersion) {
                   this.showConfirm();
                }
              }

            }
          })
      }

    },
    VersionTask() {

      try {

        // 检测前端资源是否有更新
        let response = fetch(`https://ydgx.softtone.cn/version.txt`, { cache: 'reload' }).then(response => {
          // 确保请求成功
          if (response.ok) {
            return response.text(); // 转换为文本
          }

        })
          .then(res => {

            //let versionJson = JSON.parse(res);
            let versionJson ={
              version:res
            };
            let appVersion = versionJson.version;
              if (!localStorage.getItem('appVersion')) {
                localStorage.setItem('appVersion', appVersion)
              } else {
                if (localStorage.getItem('appVersion') !== appVersion) {
                  this.showConfirm();
                }
              }


          })
      } catch (e) {
        return Promise.reject(e)
      }

    },
    StartTask() {
      this.timer = window.setInterval(() => {
        this.OrgTask();
        this.VersionTask();
      }, 1000*60*this.time);

    },
    stopTimer() {
      clearInterval(this.timer);
    }
  },
  beforeDestroy() {
    this.stopTimer();
  },
  mounted() {
    this.StartTask();

  }
}



// WEBPACK FOOTER //
// ./src/components/tool/Interval.vue